interface Props {
    className?: string;
    bgColor?: string;
}

export const CheckIcon = ({ className, bgColor = "#fff" }: Props) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <rect width="14" height="14" rx="7" fill={bgColor} />
        <path d="m4 7 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
